;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import cx from 'classnames';
import PropTypes from 'prop-types';

import { useSubNav } from './SubNavContext';
import { SubNavGroupItems } from './SubNavItems';

import styles from './SubNavRight.module.scss';

/**
 * Renders the right slide-out panel for a subnav group.
 * Reads activeSubGroupIndex from SubNavContext to determine visibility.
 */
const SubNavRight = ({ id, item, groupIndex }) => {
    const ctx = useSubNav();

    if (!ctx) return null; // Not rendered in mobile (no SubNavProvider)

    const { activeSubGroupIndex, setActiveSubGroupIndex } = ctx;
    const isActive = activeSubGroupIndex === groupIndex;

    return (
        <div className={styles.root}>
            <div
                id={id}
                className={cx(styles.subNavRight, {
                    [styles.subNavRightActive]: isActive,
                })}
                inert={isActive ? undefined : true}
                onMouseEnter={() => setActiveSubGroupIndex(groupIndex)}
                onMouseLeave={() => setActiveSubGroupIndex(-1)}
            >
                <div aria-hidden="true" className={styles.subNavRightDivider} />
                <SubNavGroupItems group={item} />
            </div>
        </div>
    );
};

SubNavRight.propTypes = {
    id: PropTypes.string,
    item: PropTypes.shape({}).isRequired,
    groupIndex: PropTypes.number.isRequired,
};

export { SubNavRight };
